export enum MicroFlowExecuteTypes {
    BUTTON = 'BUTTON',
    LOOKUP = 'LOOKUP',
    ONLOAD = 'ONLOAD'
}
